
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1004),
  allianceId1: Number.withConstraint(x => x >= 1),
  allianceId2: Number.withConstraint(x => x >= 1),
  newDiplomacy: Number.withConstraint(x => x >= 0 && x <= 10),
  oldDiplomacy: Number.withConstraint(x => x >= 0 && x <= 10),
}).And(Partial({
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1004),
  allianceId1: Number.withConstraint(x => x >= 1),
  allianceId2: Number.withConstraint(x => x >= 1),
  newDiplomacy: Number.withConstraint(x => x >= 0 && x <= 10),
  oldDiplomacy: Number.withConstraint(x => x >= 0 && x <= 10),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
}).And(Partial({
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1004;
  